// Minimal theme JS: variant select updates price and form
document.addEventListener('change', function(e){
  if(e.target.matches('[data-variant-select]')){
    var form = e.target.closest('form');
    if(!form) return;
    var id = e.target.value;
    var idInput = form.querySelector('input[name="id"]');
    if(idInput) idInput.value = id;
    var priceEl = document.querySelector('[data-variant-price="'+id+'"]');
    var mainPrice = document.querySelector('[data-product-price]');
    if(priceEl && mainPrice){ mainPrice.textContent = priceEl.dataset.price; }
  }
});
